import React from "react";
import { GoGift } from "react-icons/go";
import { TbTruckDelivery } from "react-icons/tb";
import { CiCreditCard1 } from "react-icons/ci";
import { SlReload } from "react-icons/sl";
import { useSelector } from "react-redux";

const Delivery = () => {
  const isCOD = useSelector((state) => state.fetchUser?.user?.isCOD);
  const isReturnAllowed = useSelector((state) => state.fetchUser?.user?.isReturnAllowed);

  return (
<div className={`delivery-icons ${isCOD ? 'is-cod' : 'no-cod'}`}>
  {isCOD && (
    <div className="icon-item">
      <GoGift />
      <p>COD Available</p>
    </div>
  )}
  <div className="icon-item">
    <TbTruckDelivery />
    <p>Express Shipping</p>
  </div>
  <div className="icon-item">
    <CiCreditCard1 />
    <p>Secure Payments</p>
  </div>
  {isReturnAllowed && (
    <div className="icon-item">
      <SlReload />
      <p>Easy Returns</p>
    </div>
  )}
  </div>
  );
};

export default Delivery;